export const fontSize = {
  loginInputSize: '1.8rem',
  loginInputSizeMobile: '1.1rem',
  companyTitle: '7rem',
  companyDesc: '2rem',
  circularMedium: '2rem',
  circularMediumMobile: '1.2rem',
  descTextMobile: '1.3rem',
  loginGreeting: '3rem',
  loginGreetingMobile: '2.3rem',
  headingText: '2.2rem',
  rootSize: '1.6rem',
  headingTextMobile: '1.2rem',
  default: '1rem',
  large: '3rem',
  small: '0.6rem',
  medium: '1.4rem',
  text: '1.6rem',
  title: '1.8rem',
  titleBig: '2rem',
  ToastHeader: '2.7rem'
};

export const fontFamily = {
  circularBold: 'Circular Std Bold',
  circularBook: 'Circular Std Book',
  circularMedium: 'Circular Std Medium'
};

export const fontWeight = {
  //
};
